import { cva, RecipeVariant, type RecipeVariantProps } from 'styled-system/css';

const button = cva({
  base: {
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  variants: {
    color: {
      primary: {},
      common: {},
      danger: {},
      success: {},
    },
    variant: {
      outlined: {
        backgroundColor: 'transparent',
        border: '2px solid',
      },
      contained: {
        color: 'white',
      },
      text: {},
    },
    fullWidth: {
      true: {
        width: '100%',
      },
    },
    size: {
      medium: {
        height: '48px',
        py: '10px',
        px: '15px',
        textStyle: 'h2',
      },
      small: {
        height: '30px',
        p: '10px',
        textStyle: 'b2',
      },
    },
  },
  compoundVariants: [
    {
      variant: 'contained',
      color: 'primary',
      css: {
        backgroundColor: 'purple-primary',
        '&:disabled': {
          backgroundColor: 'purple-6',
          color: 'purple-3',
        },
      },
    },
    {
      variant: 'contained',
      color: 'danger',
      css: {
        backgroundColor: 'red-1',
      },
    },
    {
      variant: 'contained',
      color: 'common',
      css: {
        backgroundColor: 'black-3',
      },
    },

    {
      variant: 'outlined',
      color: 'primary',
      css: {
        borderColor: 'purple-primary',
        color: 'purple-primary',
        '&:disabled': {
          borderColor: 'purple-3',
          color: 'purple-3',
        },
      },
    },
    {
      variant: 'outlined',
      color: 'common',
      css: {
        borderColor: 'black-3',
        color: 'black-3',
        '&:disabled': {
          borderColor: 'gray-1',
          color: 'gray-1',
        },
      },
    },
    {
      variant: 'outlined',
      color: 'danger',
      css: {
        borderColor: 'red-1',
        color: 'red-1',
        '&:disabled': {
          borderColor: 'gray-1',
          color: 'gray-1',
        },
      },
    },
    {
      variant: 'contained',
      color: 'success',
      css: {
        backgroundColor: 'green',
        '&:disabled': {
          backgroundColor: 'green-3',
          color: 'green-2',
        },
      },
    },
    {
      variant: 'outlined',
      color: 'success',
      css: {
        color: 'green-2',
        borderColor: 'green-2',
      },
    },
    {
      variant: 'outlined',
      color: 'danger',
      css: {
        borderColor: 'red-1',
        color: 'red-1',
        '&:disabled': {
          borderColor: 'gray-1',
          color: 'gray-1',
        },
      },
    },
    {
      variant: 'text',
      color: 'primary',
      css: {
        color: 'purple-2',
        '&:disabled': {
          color: 'gray-1',
        },
      },
    },
    {
      variant: 'text',
      color: 'common',
      css: {
        color: 'black-3',
        '&:disabled': {
          color: 'gray-1',
        },
      },
    },
    {
      variant: 'text',
      color: 'success',
      css: {
        color: 'green-2',
        '&:disabled': {
          color: 'gray-1',
        },
      },
    },
  ],
  defaultVariants: {
    color: 'primary',
    variant: 'contained',
    size: 'medium',
    fullWidth: false,
  },
});

export default button;

export type ButtonRecipeVariants = RecipeVariantProps<typeof button>;
export type ButtonVariants = RecipeVariant<typeof button>;
